import React from "react";
import { Button, Popover, Avatar, Box, Typography } from "@material-ui/core";
import { UserProfile } from "api/user";
import { Club } from "api/clubs";
import { ClubSelect } from "components";
import i18n from "../i18n";

// prop types
interface AccountMenuProps {
    anchorEl: HTMLButtonElement | null,
    club: Club | null,
    show: boolean,
    userProfile: UserProfile | null,
    onClose: () => void,
    onNavigateToProfile: () => void,
    onSignOut: () => void,
    onSwitchClub: (club: Club) => void,
}

// my profile menu
const AccountMenu = ({ anchorEl, club, show, userProfile, onClose, onNavigateToProfile, onSignOut, onSwitchClub }: AccountMenuProps) => (
    <Popover
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={show}
        PaperProps={{ elevation: 4, style: { minWidth: "320px", display: "flex", flexDirection: "column", alignItems: "center" } }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={onClose}
    >
        {/* profile info */}
        <Avatar src={userProfile?.profilePictureUrl} style={{ marginTop: "24px", width: "72px", height: "72px" }} />
        <Typography variant="subtitle2" style={{ marginTop: "8px" }}>
            {`${userProfile?.firstName} ${userProfile?.lastName}`}
        </Typography>
        <Typography variant="caption">
            {`${userProfile?.email}`}
        </Typography>

        {/* club select */}
        {userProfile?.memberships && (
            <Box style={{ marginTop: "16px", width: "100%", padding: "0 24px" }}>
                <ClubSelect
                    clubId={club?.id}
                    controlProps={{ fullWidth: true, variant: "outlined", margin: "dense" }}
                    helperText={`${i18n.status}: ${i18n.userRoles[userProfile?.memberships.find((m) => m.club.id === club?.id)?.userRole!]}`}
                    hideAll
                    onChange={(clubId) => onSwitchClub(userProfile?.memberships.find((m) => m.club.id === clubId)?.club!)}
                />
            </Box>
        )}

        {/* actions */}
        <Button variant="contained" style={{ marginTop: "16px" }} onClick={() => { onClose(); onNavigateToProfile(); }}>
            {i18n.userProfile}
        </Button>
        <Button color="primary" variant="contained" style={{ marginTop: "16px", marginBottom: "24px" }} onClick={onSignOut}>
            {i18n.signOut}
        </Button>
    </Popover>
);

export default AccountMenu;
